module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_4_3.41d2de8e.jpeg";